export class MapProgram {
    public id: number;
    public name: string;
    public websiteUrl: string;
    public phoneNumber: string;
    public address: string;
    public lat: string;
    public lng: string;
    public selected: boolean;
}


// WEBPACK FOOTER //
// C:/WORK/Projects/ActNow_NG2/src/models/map/map-program.ts